import * as React from 'react';
import { Component } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { __ } from '../../core/utils';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import { enableAutosave } from '../../redux/actions/general/autosave';
import { withRouter } from 'react-router';
import Input from '../../components/Input';
import Select from '../../components/Select';
import DateTimePicker from '../../components/DateTimePicker';
import PeopleChooser from '../../components/PeopleChooser';
import { listPossibleLeaveParticipants } from '../../redux/actions/table/timesheets';
import { listRoles } from '../../redux/actions/table/company_roles_and_permissions';
import MultiSelect from '../../components/MultiSelect';

const mapStateToProps = (state) => {
  return {
    values: getFormValues('company_folders.details')(state),
  };
};

@reduxForm({
  form: 'company_folders.details',
  enableReinitialize: true,
})
@subscribe(Localization, 'localization')
@connect(mapStateToProps)
@withRouter
class EditCompanyFoldersForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      possible_users_for_entry: [],
      possible_roles_for_entry: [],
    };
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  componentDidMount() {
    // listPossibleLeaveParticipants().then(({ response }) => {
    //   this.setState({
    //     possible_users_for_entry: _.map(response.data, (row) => ({
    //       ...row,
    //       name: row.fullname,
    //     })),
    //   });
    // });
    listRoles().then(({ response }) => {
      this.setState({
        possible_roles_for_entry: _.map(response.data, (row) => ({
          ...row,
          value: row.id,
          label: row.name + ' (' + row.user_count + ')',
        })),
      });
    });
  }

  render() {
    const { possible_users_for_entry, possible_roles_for_entry } = this.state;

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <Field
          name='name'
          component={Input}
          label={__('edit-company-folders-form.name')}
        />
        {/* <Field
          name='user_ids'
          component={PeopleChooser}
          label={__('edit-company-folders-form.users')}
          searchable
          options={possible_users_for_entry}
        /> */}
        <Field
          name='role_ids'
          component={MultiSelect}
          label={__('edit-company-folders-form.roles')}
          placeholder={__('edit-company-folders-form.select-role')}
          searchable
          options={possible_roles_for_entry}
        />
      </Form>
    );
  }
}

export default EditCompanyFoldersForm;
